import { useTiles } from '@/srp/ResultsSection/hooks';
import { LOW_RESULTS_THRESHOLD } from '~/constants/srp';
import {
  useFreeTextNoResults,
  useInventoryVehicles,
  useSimilarVehicles
} from '~/context/srp/InventoryContext';
import useGetVehiclesLoaded from './useGetVehiclesLoaded';

function useLoadedInventoryVehicles() {
  const inventoryVehicles = useInventoryVehicles();
  const { vehicles: similarVehicles, searchRequestId: svSearchRequestId } =
    useSimilarVehicles();
  const freeTextNoResults = useFreeTextNoResults();

  const tiles = useTiles();
  // Free-text-no-results never fetches similar vehicles (that's a different,
  // filter-based low-results feature), so it should never wait on them.
  const shouldHaveSimilarVehicles =
    tiles.length < LOW_RESULTS_THRESHOLD && !freeTextNoResults;

  const { loadedInventoryVehicles, loadedSimilarVehicles } =
    useGetVehiclesLoaded({
      latestInventoryVehicles: inventoryVehicles,
      latestSimilarVehicles: similarVehicles,
      shouldHaveSimilarVehicles
    });

  return {
    loadedInventoryVehicles,
    loadedSimilarVehicles,
    shouldHaveSimilarVehicles,
    svSearchRequestId
  };
}

export default useLoadedInventoryVehicles;
